"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeOptions = exports.fixSchemaOptions = exports.registerSchemaMethod = exports.defaultOptions = void 0;
var schemaMethods = require("../schemaMethods");
var validationMessages_1 = require("../validationMessages");
/**
 * domyslne opcje schematu
 */
exports.defaultOptions = {
    Vue: null,
    resetOnFocus: true,
    dirtyOnInput: false,
    dirtyOnBlur: true,
    disableCalculations: false,
    disableValidations: false,
    startDirty: false,
    schemaMethods: schemaMethods,
    wrapAll: false,
    fixData: true,
    fixFormat: false,
    validationMessages: validationMessages_1.default,
    warningMessages: validationMessages_1.default,
    form: {},
    external: {},
    disabledFields: {}
};
/**
 * rejestrownie metody globalnej dla schema
 * @param name nazwa metody
 * @param fn funkcja
 */
function registerSchemaMethod(name, fn) {
    exports.defaultOptions.schemaMethods[name] = fn;
}
exports.registerSchemaMethod = registerSchemaMethod;
/**
 * łączenie opcji z opcjami domyslnymi
 *
 * @export
 * @param {*} [options]
 * @returns {IOptions}
 */
function fixSchemaOptions(options) {
    var result = {};
    mergeOptions(result, exports.defaultOptions);
    if (options) {
        mergeOptions(result, options);
    }
    return result;
}
exports.fixSchemaOptions = fixSchemaOptions;
/**
 * dołaczanie opcji *
 * @export
 * @param {IOptions} options
 * @param {IOptions} optionsToMerge
 * @param {number} level poziom opcji
 */
function mergeOptions(options, optionsToMerge, level) {
    if (level === void 0) { level = 0; }
    for (var key in optionsToMerge) {
        if (optionsToMerge.hasOwnProperty(key)) {
            var value = optionsToMerge[key];
            if (value !== undefined) {
                if (level === 0) {
                    switch (key) {
                        case 'external':
                        case 'form':
                        case 'Vue':
                            options[key] = value;
                            continue;
                        case 'schemaMethods':
                            if (options.schemaMethods) {
                                options.schemaMethods = Object.assign({}, options.schemaMethods, optionsToMerge.schemaMethods);
                            }
                            else {
                                options.schemaMethods = optionsToMerge.schemaMethods;
                            }
                            continue;
                    }
                }
                if (typeof value === 'object' && value != null && !Array.isArray(value)) {
                    if (options[key] === undefined) {
                        options[key] = {};
                    }
                    mergeOptions(options[key], value, level + 1);
                }
                else {
                    options[key] = value;
                }
            }
        }
    }
}
exports.mergeOptions = mergeOptions;
//# sourceMappingURL=IOptions.js.map